import React from "react";
import myImg from "../../Assets/dip.jpg";
import Typewriter from "typewriter-effect";
import Profile from "../Profile/Profile";
import Skills from "../Skills/Skills";
import Resume from "../Resume/Resume";
import Contact from "../Contact/Contact";
import Services from "../Services/Services";
import GoToTop from "../GoToTop";
import Facts from "../Facts/Facts";
import "./home.module.css";
import "./styles.css";
import Fade from 'react-reveal/Fade';


function Home(props) {
  return (
    <>
      <Scroll></Scroll>
      <Profile></Profile>
      <Skills></Skills>
      <Services></Services> 
      <Resume></Resume>
      <Contact></Contact>
      <GoToTop />
    </>
  );
}

const Scroll = () => {
  return (
    <>
      {" "}
      <section id="scroll">
        <div class="container px-5">
          <div class="row gx-5 align-items-center">
            <div class="col-lg-6 order-lg-2">
              <div class="p-5">
                <img class="img-fluid rounded-circle" src={myImg} alt="..." />
              </div>
            </div>
            <div class="col-lg-6 order-lg-1">
              <div class="p-5">
                {/* <h2 class="display-4">
              Hi There!{" "}
              <span className="wave" role="img" aria-labelledby="wave">
                👋🏻
              </span>
            </h2> */}
                <h1 className="heading-name">
                  I'm
                  <strong className="main-name"> Dipam Halder</strong>
                </h1>
                <h3 className="fluidz-48 mb-1x">
                  <Typewriter
                    options={{
                      strings: [
                        "I'm MERN Stack Developer.",
                        "I love coding.",
                        "I code cool websites.",
                      ],
                      autoStart: true,
                      loop: true,
                      deleteSpeed: 10,
                    }}
                  />
                </h3>
                <Fade left>

                <p>
                  I am passionate about using Javascript and Animation Libraries
                  to create awesome user experiences. With over two years of
                  experience developing web applications using the latest
                  front-end and back-end technologies.
                </p>
                </Fade>
                <div class="social-links">
                  <a
                    href="https://github.com/halderdipam"
                    target="_blank"
                    className="github"
                  >
                    <i className="bx bxl-github"></i>
                  </a>
                  <a
                    href="https://twitter.com/DipamHalder3"
                    class="twitter"
                    target="_blank"
                  >
                    <i class="bx bxl-twitter"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/dipam.halder.71/"
                    class="facebook"
                    target="_blank"
                  >
                    <i class="bx bxl-facebook"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/diapmhalde/"
                    target="_blank"
                    class="instagram"
                  >
                    <i class="bx bxl-instagram"></i>
                  </a>
                  <a
                    href="https://secure.skype.com/portal/overview"
                    target="_blank"
                    class="google-plus"
                  >
                    <i class="bx bxl-skype"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/dipam-halder-1a866a193/"
                    className="linkedin"
                    target="_blank"
                  >
                    <i class="bx bxl-linkedin"></i>
                  </a>

                  <a
                    className="linkedin"
                    href="https://wa.me/918001388527?text=Hi, I'm interested.."
                    target="_blank"
                  >
                    <i class="bi bi-whatsapp "></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Facts></Facts>
      </section>
    </>
  );
};
export default Home;
